import React, { useEffect, useState } from "react";
import {
  CAROUSEL_NEXT_PREV_BUTTON_VALUE,
  PUBLIC_HEADER_TABS,
  PUBLIC_TABS,
} from "../../utils/AppEnumerations";
import {
  darkStarIcon,
  leftChevronIcon,
  rightChevronIcon,
} from "../../assets/icons/SvgIconList";
import { IServiceForSubCategory } from "../../screens/product-services/Web/ProductServiceDetailsWebController";
import { fetchPublicServiceApi } from "./OfferingController";
import PublicHeader from "../public-header/PublicHeader";
import ICPureImage from "../../core-component/ICPureImage";
import Modal from "../../components/PublicModal";
import usePaginationHook from "../../hooks/UsePaginationHook";
import { PAGINATION_PER_PAGE_ROWS } from "../../utils/AppConstants";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import CopyrightFooter from "../../components/common/CopyrightFooter";
import PublicServiceCarousel from "../../components/PublicServiceCarousel";
import Loader from "../../components/common/Loader";
import PublicTrendingServiceCarousel from "../../components/PublicTrendingServiceCarousel";
import UseMobileLayoutHook from "../../hooks/UseMobileLayoutHook";

const Offerings: React.FC = () => {
  // Keep all the comments of the page as needed for future reference
  // const carouselRef = useRef<Carousel>(null);
  const [loading, setLoading] = useState(true);
  let timer: NodeJS.Timeout;
  const [otherServicesList, setOtherServicesList] = useState<
    IServiceForSubCategory[]
  >([]);
  const [trendingServicesList, setTrendingServicesList] = useState<
    IServiceForSubCategory[]
  >([]);
  const { isMobile } = UseMobileLayoutHook();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [publicLoader, setPublicLoader] = useState(true);
  const [serviceId, setServiceId] = useState<number>();
  const { pagination: trendPagination, setPagination: setTrendPagination } =
    usePaginationHook({
      pagination: {
        per_page_rows: Number(PAGINATION_PER_PAGE_ROWS.Hundred),
        current_page: 1,
        sort_by: "",
        order_by: "DESC",
      },
    });
  const { pagination: servicePagination, setPagination: setServicePagination } =
    usePaginationHook({
      pagination: {
        per_page_rows: isMobile
          ? Number(PAGINATION_PER_PAGE_ROWS.Hundred)
          : Number(PAGINATION_PER_PAGE_ROWS.Twelve),
        current_page: 1,
        sort_by: "",
        order_by: "DESC",
      },
    });

  const { t } = UseTranslationHook();
  useEffect(() => {
    fetchPublicServiceApi(
      setOtherServicesList,
      setLoading,
      servicePagination,
      setServicePagination,
      otherServicesList,
      false
    );
  }, [servicePagination.current_page]);

  useEffect(() => {
    document.title = PUBLIC_TABS.Offerings;
    fetchPublicServiceApi(
      setTrendingServicesList,
      setLoading,
      { ...trendPagination, per_page_rows: 12 },
      setTrendPagination,
      trendingServicesList,
      true
    );
  }, []);
  const handleClick = (id: number) => {
    setServiceId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleCarouselSlide = (direction: string) => {
    // if (carouselRef.current) {
    if (direction === CAROUSEL_NEXT_PREV_BUTTON_VALUE.Next) {
      // carouselRef.current.next(CAROUSEL_SLIDE_PRE_CLICK.One)
      // if ((carouselRef.current.state.currentSlide) * 3 + 6 >= servicesList.length) {
      setServicePagination({
        ...servicePagination,
        current_page: servicePagination.current_page + 1,
      });
      // }
    } else if (direction === CAROUSEL_NEXT_PREV_BUTTON_VALUE.Previous) {
      // carouselRef.current.previous(CAROUSEL_SLIDE_PRE_CLICK.One);
      setServicePagination({
        ...servicePagination,
        current_page: servicePagination.current_page - 1,
      });
    }
  };

  const truncateText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) {
      return text;
    } else {
      return text.substring(0, maxLength);
    }
  };
  const extractPlainText = (html: string): string => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  useEffect(() => {
    setTimeout(async () => {
      setPublicLoader(false);
    }, 2000);
  });

  return (
    <div className="bg-skin-home-bg h-screen overflow-y-scroll remove-scrollbar-width">
      {loading || publicLoader ? (
        <div className="h-screen flex items-center flex-col bg-black">
          <Loader />
        </div>
      ) : (
        <>
          <div className="h-24">
            <PublicHeader activeTab={PUBLIC_HEADER_TABS.Offerings} />
          </div>

          {otherServicesList && otherServicesList.length > 0 && (
            <div className="flex justify-center mt-3  relative">
              <div className="w-full mb-12">
                <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 grid-flow-row overflow-x-scroll gap-3">
                  {otherServicesList.map((service, index) => (
                    <div
                      key={index}
                      className="overflow-hidden  cursor-pointer"
                      onClick={() => handleClick(service.id)}
                    >
                      <div className="relative service-image ml-3 mr-3 lg:ml-0 lg:mr-0 overflow-hidden transition-all duration-500">
                        {service.app_media && (
                          <ICPureImage
                            imageUrl={service.app_media[0]?.media_url}
                            alt={service.service_title}
                            wrapperClassName="w-full h-full aspect-[16/9] border-[0.5px] border-[#363636]"
                            className="aspect-[16/9] object-contain"
                          />
                        )}
                        {!isMobile && (
                          <div className="service-detail hidden w-full absolute top-0 h-full overflow-hidden">
                            <div className=" flex flex-col justify-between h-full p-4">
                              <div className="text-2xl text-skin-title-insights">
                                {service.service_title}
                              </div>
                              <div className="text-lg text-skin-insights">
                                {truncateText(
                                  extractPlainText(service.service_desc),
                                  200
                                )}
                                ...
                              </div>
                              {service.service_rating && (
                                <div className="flex items-center w-full text-skin-insights">
                                  <div className="w-5 h-5 mr-3">
                                    {darkStarIcon}
                                  </div>
                                  <div className="text-lg text-skin-insights ">
                                    {service.service_rating.map(
                                      (item, index) => (
                                        <div className="flex">
                                          <div className="mr-2">
                                            {item.average_rating}
                                          </div>
                                          <div> ({item.total_reviews})</div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        <div className="service-title ml-[1px] w-[99.50%] text-skin-insights text-2xl left-0 bottom-0 p-2 absolute">
                          {service.service_title}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {!isMobile && (
                <div
                  className={`flex ${
                    servicePagination.current_page === 1
                      ? `justify-end`
                      : `justify-between`
                  }  w-full absolute top-[50%]`}
                >
                  {servicePagination.current_page === 1 ? (
                    ""
                  ) : (
                    <div
                      className="flex justify-center items-center !hover:bg-red-500 cursor-pointer w-30 h-20 bg-skin-chevron-bg"
                      onClick={() =>
                        handleCarouselSlide(
                          CAROUSEL_NEXT_PREV_BUTTON_VALUE.Previous
                        )
                      }
                    >
                      <div className="h-20 w-20">{leftChevronIcon}</div>
                    </div>
                  )}

                  {servicePagination.total_page &&
                    servicePagination.current_page !==
                      servicePagination.total_page && (
                      <div
                        className="flex justify-center cursor-pointer items-center w-30 h-20 bg-skin-chevron-bg"
                        onClick={() =>
                          handleCarouselSlide(
                            CAROUSEL_NEXT_PREV_BUTTON_VALUE.Next
                          )
                        }
                      >
                        <div className="h-20 w-20">{rightChevronIcon}</div>
                      </div>
                    )}
                </div>
              )}
            </div>
          )}
          {trendingServicesList && trendingServicesList.length > 0 && (
            <div className="w-full flex flex-col mt-6 justify-center items-center">
              <div className="xl:w-3/4 text-4xl text-skin-insights w-full text-center">
                {t("trending_now")}
              </div>
              <div className="desktop-carousel mt-[-60px] w-full">
                <PublicServiceCarousel items={trendingServicesList} />
              </div>
              <div className="mobile-carousel h-full w-full">
                <PublicTrendingServiceCarousel items={trendingServicesList} />
              </div>
            </div>
          )}
          {isModalOpen && serviceId && (
            <Modal id={serviceId} closeModal={closeModal} />
          )}
          <CopyrightFooter />
        </>
      )}
    </div>
  );
};

export default Offerings;
